// eslint-disable-next-line import/no-cycle
import { $themeBreakpoints } from '@themeConfig'
import useJwt from '@/auth/jwt/useJwt'
import { LANG_LEVEL_INDICATOR } from '@/const/langLevel'

let partnerCompanyInfo
try {
  partnerCompanyInfo = JSON.parse(localStorage.getItem('partnerInformation'))
} catch {
  partnerCompanyInfo = null
}

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    partnerCompanyInfo,
    companyLogo: partnerCompanyInfo?.logo || '/img/logo.023152ca.svg',
    // Currently applied indicator (may be a course-level override).
    languageLevelIndicator: LANG_LEVEL_INDICATOR,
    // School-level baseline for the classroom in context. Course overrides fall
    // back to this once the course is deselected / the report view is left.
    schoolLanguageLevelIndicator: LANG_LEVEL_INDICATOR,
  },
  getters: {
    isNarrowMode: state => state.windowWidth < 768,
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  actions: {
    async getLanguageLevelByCourse({ commit }, payload) {
      const response = await useJwt.getLanguageLevelByCourse({
        params: {
          ...payload,
        },
      })
      if (response.data.data.indicator) {
        commit('SET_LANGUAGE_LEVEL_INDICATOR', response.data.data.indicator)
      } else {
        // No course-level override: fall back to the school-level baseline.
        commit('RESET_LANGUAGE_LEVEL_INDICATOR')
      }
    },
    async getLanguageLevelIndicatorBySchool({ commit }, schoolId) {
      if (!schoolId) return
      const response = await useJwt.getLanguageLevelIndicatorBySchool(schoolId)
      const { indicator } = response.data.data
      // Records the school-level baseline; only overrides the active value when
      // the school actually has an associated indicator.
      commit('SET_SCHOOL_LANGUAGE_LEVEL_INDICATOR', indicator || null)
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_COMPANY_INFORMATION(state) {
      if (state.partnerCompanyInfo) {
        localStorage.setItem('partnerInformation', JSON.stringify(state.partnerCompanyInfo))
      }
    },
    SET_COMPANY_LOGO(state, val) {
      state.companyLogo = val.logo
      state.partnerCompanyInfo = val
    },
    SET_LANGUAGE_LEVEL_INDICATOR(state, val) {
      if (val) {
        state.languageLevelIndicator = val
      } else {
        state.languageLevelIndicator = LANG_LEVEL_INDICATOR
      }
    },
    SET_SCHOOL_LANGUAGE_LEVEL_INDICATOR(state, val) {
      state.schoolLanguageLevelIndicator = val || LANG_LEVEL_INDICATOR
      if (val) {
        state.languageLevelIndicator = val
      }
    },
    RESET_LANGUAGE_LEVEL_INDICATOR(state) {
      state.languageLevelIndicator = state.schoolLanguageLevelIndicator || LANG_LEVEL_INDICATOR
    },
  },
}
